import React, { useEffect, useState } from 'react';
import { FaBullhorn, FaExternalLinkAlt } from 'react-icons/fa';
import { fetchAnnouncements } from '../config';
import './AnnouncementsPage.css';

const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const loadAnnouncements = async () => {
      try {
        const data = await fetchAnnouncements();
        if (cancelled) return;
        if (Array.isArray(data) && data.length > 0 && data[0].message) {
          setAnnouncements(data);
        }
      } catch (err) {
        if (cancelled) return;
        console.error('Failed to fetch announcements', err);
        setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadAnnouncements();
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="announcements-page fade-in-up">
      <div className="announcements-wrapper">
        <span className="badge announcements-badge">Updates</span>
        <h1 className="announcements-heading">Announcements</h1>
        <p className="announcements-subtitle">
          Stay up to date with the latest news and updates from ICES2026.
        </p>

        {loading && (
          <div className="announcements-loading">
            <div className="announcements-spinner" />
            <p>Loading announcements...</p>
          </div>
        )}

        {!loading && error && (
          <div className="announcements-empty">
            <FaBullhorn className="announcements-empty-icon" />
            <p>Unable to load announcements at this time. Please try again later.</p>
          </div>
        )}

        {!loading && !error && announcements.length === 0 && (
          <div className="announcements-empty">
            <FaBullhorn className="announcements-empty-icon" />
            <p>No announcements at the moment. Check back soon!</p>
          </div>
        )}

        {!loading && !error && announcements.length > 0 && (
          <div className="announcements-list">
            {announcements.map((item, index) => (
              <div className="announcement-card" key={index}>
                <div className="announcement-card-indicator" />
                <div className="announcement-card-icon">
                  <FaBullhorn />
                </div>
                <div className="announcement-card-content">
                  <div className="announcement-card-number">Announcement {announcements.length - index}</div>
                  <p className="announcement-card-message">{item.message}</p>
                  {item.link && (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="announcement-card-link"
                    >
                      Learn more <FaExternalLinkAlt style={{ fontSize: '0.65rem', marginLeft: '4px' }} />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default AnnouncementsPage;
